import {
  CLEAN_COMPANIES, GET_COMPANIES, SAVE_COMPANY, GET_COMPANY, ARCHIVE_COMPANY,
  SET_CURRENT_COMPANY, RESTORE_COMPANY
} from './types';
import {
  createCompanyQuery, archiveCompanyQuery, getCompanyQuery, listCompaniesQuery,
  updateCompanyQuery, restoreCompanyQuery
} from '../../graphql';
import api from '../../apiClient';

export function getCompanies(variables = {}) {
  return {
    type: GET_COMPANIES,
    payload: api.graphql(listCompaniesQuery, variables)
  };
}

export function getCompany(variables = {}) {
  return {
    type: GET_COMPANY,
    payload: api.graphql(getCompanyQuery, variables)
  };
}

export function setCurrentCompany(id) {
  return {
    type: SET_CURRENT_COMPANY,
    payload: api.graphql(getCompanyQuery, { id })
  };
}

export function cleanCompanies(extraProps = {}) {
  return {
    type: CLEAN_COMPANIES,
    payload: Promise.resolve(extraProps)
  };
}

export function saveCompany(variables = {}) {
  const query = variables.input.id ? updateCompanyQuery : createCompanyQuery;
  return {
    type: SAVE_COMPANY,
    payload: api.graphql(query, variables)
  };
}

export function archiveCompany(id) {
  return {
    type: ARCHIVE_COMPANY,
    payload: api.graphql(archiveCompanyQuery, { id })
  };
}

export function restoreCompany(id) {
  return {
    type: RESTORE_COMPANY,
    payload: api.graphql(restoreCompanyQuery, { id })
  };
}
